import $ from 'jquery';
import EdeeshopPopup from './components/EdeeshopPopup';

// export to window
window.$ = $;
window.jQuery = $;

/**
 * Edeeshop Popup init
 */
window.edeeshopPopup = new EdeeshopPopup();



// WEBPACK FOOTER //
// ./fe/web-default/src/js/windowExports.js